import { ContactForm } from './ContactForm'

export function FugueContactForm() {
  return (
    <ContactForm
      header="Ready to Modernize Your Festival?"
      body="Tell us about your festival, your digital challenges, and what you're hoping to achieve. We'll get back to you within 24 hours to discuss how we can help grow your enrollment and streamline your operations."
      showBooking
      bookingHeading="Prefer a call? Grab a free time below."
    />
  )
}
